import { BaseRestRepository } from './baseRestRepository';
import type { ChartOfAccountDto, CreateChartOfAccountDto, UpdateChartOfAccountDto } from '~/swagger/portal/Api';

const CHART_OF_ACCOUNTS_URL = '/api/chart-of-accounts';

export class ChartOfAccountsRepository extends BaseRestRepository {
  public async getChartOfAccounts(): Promise<ChartOfAccountDto[]> {
    const url = CHART_OF_ACCOUNTS_URL;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async createChartOfAccount(data: CreateChartOfAccountDto) {
    const url = CHART_OF_ACCOUNTS_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return this.getJsonResponse(response);
  }

  public async updateChartOfAccount(id: string, data: UpdateChartOfAccountDto): Promise<ChartOfAccountDto> {
    const url = `${CHART_OF_ACCOUNTS_URL}/${id}`;
    const response = await this.fetchWithAuth(url, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
    return this.getJsonResponse(response);
  }

  public async deleteChartOfAccount(id: string, replacementId: string): Promise<void> {
    const url = `${CHART_OF_ACCOUNTS_URL}/${id}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
      body: JSON.stringify({ replacementId }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}
